/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */
import 'date-fns';
import { useState } from 'react';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import DateFnsUtils from '@date-io/date-fns';
import ptBR from 'date-fns/locale/pt-BR';
// @ts-ignore
import pt from 'moment/locale/pt-br';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import { toast } from 'react-toastify';
import NavCommon from '../../components/navCommon';
import Input from '../../components/input';
import {
  Form,
  Cards,
  ColumnForm,
  RowForm, Footer,
  RowInput,
  Padding,
  style,
  ContainerExt,
} from './styles';
import Container from '../../components/container';
import axios from '../../services/axiosServicesAgendamentos';
import LoadingCommon from '../../components/LoadingCommon';

interface Params {
  poleposition: any;
  edit: boolean;
}

const NewScheduleReservation = () => {
  const history = useHistory();
  const [name, setName] = useState<string | null>('');
  const [dateIniti, setDateInit] = useState<string | null>(null);
  const [dateEnd, setDateEnd] = useState<string | null>(null);
  const [initSechedule, setScheduleInit] = useState('');
  const [endSchedule, setSchedule] = useState('');
  const [loadingSave, setLoadingSave] = useState<boolean>(false);

  const handleDateChangeInit = (date: any) => {
    const newDate: string | null = moment(date).add(1, 'day').format('YYYY-MM-DD');
    setDateInit(newDate);
  };
  const handleDateChangeEnd = (date: any) => {
    const newDate: string | null = moment(date).add(1, 'day').format('YYYY-MM-DD');
    setDateEnd(newDate);
  };
  const handleScheduleInit = (date: any) => {
    setScheduleInit(moment(date.target.value).format('YYYY-MM-DD HH:mm:ss'));
  };
  const handleScheduleEnd = (date: any) => {
    setSchedule(moment(date.target.value).format('YYYY-MM-DD HH:mm:ss'));
  };

  const clearStates = () => {
    setName('');
    setDateInit(null);
    setDateEnd(null);
    setScheduleInit('');
    setSchedule('');
  };

  const save = async () => {
    try {
      if (!name || !initSechedule || !endSchedule || !dateIniti || !dateEnd) {
        toast.error('Informe todos os campos!');
        return;
      }

      setLoadingSave(true);
      await axios.post('/admin/agendas/v1', {
        dataInicioAgenda: moment(dateIniti).subtract(1, 'day').format('YYYY-MM-DD').toString(),
        dataEncerramentoAgenda: moment(dateEnd).subtract(1, 'day').format('YYYY-MM-DD').toString(),
        nomeAgenda: name,
        dataHoraInicioReservaPosicoes: initSechedule.replace('T', ' '),
        dataHoraEncerramentoReservaPosicoes: endSchedule.replace('T', ' '),
      });
      toast.success('Enviado pedido para a criação da Agenda.');
      clearStates();
      setLoadingSave(false);
    } catch (error) {
      setLoadingSave(false);
    }
  };

  return (
    <>
      <NavCommon
        breadcrumbs={[]}
        hasOnChange={false}
        onBack={() => { history.goBack(); }}
        onChange={() => {
          history.push({ pathname: '/cadastrar/locais', state: { edit: false } });
        }}
      />
      <ContainerExt>
        <Container component="div" maxWidth="lg">
          <Cards>
            <Form>
              <RowForm>
                <ColumnForm>
                  <Padding style={{ width: '39%' }}>
                    <Input value={name || ''} onChange={setName} type="text" label="Nome da agenda" />
                  </Padding>
                  <RowInput>
                    <Padding>
                      <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          autoOk
                          disableToolbar
                          variant="inline"
                          format="dd/MM/yyyy"
                          margin="normal"
                          id="date-picker-inline"
                          style={{ width: '80%' }}
                          label="Data de início da agenda"
                          value={dateIniti}
                          onChange={handleDateChangeInit}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </Padding>
                    <Padding>
                      <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          autoOk
                          variant="inline"
                          format="dd/MM/yyyy"
                          margin="normal"
                          id="date-picker-inline"
                          label="Data de encerramento da agenda"
                          value={dateEnd}
                          style={{ width: '80%' }}
                          onChange={handleDateChangeEnd}
                          KeyboardButtonProps={{
                            'aria-label': 'change date',
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </Padding>
                  </RowInput>
                  <RowInput>
                    <Padding>
                      <TextField
                        id="datetime-local"
                        label="Data e horário início de reserva"
                        type="datetime-local"
                        onChange={(event) => {
                          handleScheduleInit(event);
                        }}
                        style={{ width: '80%', marginTop: 18 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Padding>
                    <Padding>
                      <TextField
                        id="datetime-local"
                        label="Data e horário fim de reserva"
                        type="datetime-local"
                        onChange={handleScheduleEnd}
                        style={{ width: '80%', marginTop: 18 }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Padding>
                  </RowInput>
                </ColumnForm>
              </RowForm>
              <Footer>
                {loadingSave ? (
                  <div style={{
                    display: 'flex', justifyContent: 'flex-end', width: '100%', marginRight: 45,
                  }}
                  >
                    <LoadingCommon />
                  </div>
                ) : (
                  <Button variant="contained" onClick={() => save()} style={style.text}>
                    Salvar
                  </Button>
                )}
              </Footer>
            </Form>
          </Cards>
        </Container>
      </ContainerExt>
    </>
  );
};

export default NewScheduleReservation;
